module.exports = __webpack_public_path__ + "img/mm.eb7cabbb.svg";